import { createContext, useCallback, useContext, useSyncExternalStore } from "react";
import { createComposerDraftStore, type ComposerDraft, type DraftSetter } from "./composerDraftStore";

export const ComposerDraftContext = createContext<ReturnType<typeof createComposerDraftStore> | null>(null);
export function useComposerDraftField<K extends keyof ComposerDraft>(key: string, field: K): [ComposerDraft[K], DraftSetter<K>] {
  const store = useContext(ComposerDraftContext);
  if (!store) throw new Error("Composer needs a workspace draft provider");
  const value = useSyncExternalStore(store.subscribe, () => store.get(key)[field]);
  const set = useCallback<DraftSetter<K>>((next) => { store.set(key, field, next); }, [store, key, field]);
  return [value, set];
}
